import useTranslate from 'modules/local/useTranslate'
import React, {useMemo, useState} from 'react'
import {NullAsDefault} from 'views/Shared'
import {notifyOnError} from "../../factory/createErrorEvent";
import {bindQueryParam} from "../../functions/routerHelper";
import {profile_createProfile_Api, profile_deleteProfile_Api, profile_updateProfile_Api} from "../../../../apis";
import {NotificationActionTypes, successNotify} from "../../factory/createNotification";
import useAsyncAction from "../../../../modules/asyncCache/useAsyncAction";
import CRUD from "../../../Shared/enums/CRUD";
import {Modal} from "antd";
import {DelayRender} from "../../../Shared/components/DelayRender";
import ProfileContext, {ProfileProvider} from "../ProfileContext";
import {DetailForm} from "../components/ProfileForm";
import LoadingBlock from "../../../Loading/LoadingBlock";


export const useProfileFunc = ({
                                 notifyListeners = {
                                   onCreated: undefined,
                                   onUpdated: undefined,
                                   onDeleted: undefined,
                                 },
                               }) => {
  const t = useTranslate()
  const [action, setAction] = useState({type: undefined, value: undefined})

  const {
    onCreated = NullAsDefault,
    onUpdated = NullAsDefault,
    onDeleted = NullAsDefault,
  } = notifyListeners ?? {}

  const onError = notifyOnError(t)

  const {handleAsyncAction: onCreate, ...asyncCreating} = useAsyncAction({
    onError,
    query: bindQueryParam({}),
    apiInfo: profile_createProfile_Api,
    onSuccess: (result, data) => {
      successNotify(NotificationActionTypes.CREATE, t)
      onCreated(result, data)
    },
  })

  const {handleAsyncAction: onUpdate, ...asyncUpdating} = useAsyncAction({
    onError,
    apiInfo: profile_updateProfile_Api,
    onSuccess: (result, data) => {
      successNotify(NotificationActionTypes.UPDATE, t)
      onUpdated(result, data)
    },
  })

  const {handleAsyncAction: onDelete, ...asyncDeleting} = useAsyncAction({
    onError,
    apiInfo: profile_deleteProfile_Api,
    onSuccess: (result, data) => {
      successNotify(NotificationActionTypes.DELETE, t)
      onDeleted(result, data)
    },
  })

  const handleAction = (action, params) => {
    switch (action) {
      case CRUD.READ:
        setAction({type: action, value: params})
        break
      default:
        break
    }
  }

  const onCancel = () => {
    setAction({})
  }
  const showProfileModal = (params) => {
    return handleAction(CRUD.READ, params)
  }

  const profileModal = useMemo(() => {
    let Content = NullAsDefault
    let Wrapper = ({children}) => children({initialValues: {}})
    let params = {initValues: {...action.value}}
    let modal_params = {}

    switch (action.type) {
      case CRUD.READ:
        params = {}
        modal_params = {
          width: 600,
          title: (
              <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                {t('character info')}
              </div>
          ),
        }
        Content = ({...rest}) => (
            <ProfileProvider item={action.value}>
              <ProfileContext.Consumer>
                {({item}) => {
                  return (
                      <DetailForm
                          {...rest}
                          item={item}
                          reportAccess={false}
                      />
                  )
                }}
              </ProfileContext.Consumer>
            </ProfileProvider>
        )
        break
      default:
        break
    }

    return (
        <Modal
            className="custom-modal"
            footer={null}
            onCancel={onCancel}
            open={action.type && action.type !== CRUD.DELETE}
            destroyOnHidden={true}
            {...modal_params}>
          <DelayRender lazy={true}>
            <Wrapper>
              {({isLoading, initialValues}) => {
                if (!!isLoading) {
                  return <LoadingBlock/>
                }
                return (
                    <Content
                        {...{
                          onCancel,
                          item: action.value,
                        }}
                        {...params}
                        initialValues={initialValues}
                    />
                )
              }}
            </Wrapper>
          </DelayRender>
        </Modal>
    )
  }, [action])

  return {
    showProfileModal,
    profileModal,
    onCreate,
    onUpdate,
    onDelete,
    asyncCreating,
    asyncUpdating,
    asyncDeleting,
  }
}



